import StatsCard from "../../../components/stats-card";

export default function ExpiringStockCard({
  styles,
  totalExpiredDisplay,
  expiredBranchesDisplay,
  nearingExpiryDisplay,
  expiredKpiError,
  onOpen,
}) {
  return (
    <StatsCard title="Expiring Stock" icon="expiry" onClick={onOpen}>
      <p className={styles.warningNumber}>{totalExpiredDisplay}</p>
      <p className={styles.warningText}>
        items across {expiredBranchesDisplay} branches
      </p>

      <p className={styles.criticalText}>
        {nearingExpiryDisplay} items critical (&lt;30 days)
      </p>
      {expiredKpiError && (
        <p className="text-red-500 text-xs mt-1">{expiredKpiError}</p>
      )}
    </StatsCard>
  );
}
